export enum CalendarView {
  dayGridMonth = "dayGridMonth",
  timeGridWeek = "timeGridWeek",
  listMonth = "listMonth",
  list = "list",
  timeline = "timeline",
}

export enum CalendarViewPreference {
  month = "month",
  agendaWeek = "agendaWeek",
  basicDay = "basicDay",
  timeline = "timeline",
}

export type DateClickInfo = {
  date: Date;
  dateStr: string;
  allDay: boolean;
  resource?: any;
  dayEl: HTMLElement;
  jsEvent: MouseEvent;
  view: any;
};

// stricter implementation defined in FC but unexported
export interface OptionsInputBase {
  [key: string]: any;
}
